(function () {
  'use strict';

  function floridazeGtag() {
    if (typeof window.gtag === 'function') {
      window.gtag.apply(null, arguments);
    } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(arguments);
    }
  }
  window.floridazeTrackEvent = floridazeGtag;

  function isOutboundLink(anchor) {
    if (!anchor) return false;
    var href = anchor.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) return false;
    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return false;
    }
    return !!url.hostname && url.hostname !== window.location.hostname;
  }

  document.addEventListener('click', function (e) {
    var anchor = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!isOutboundLink(anchor)) return;
    var url = new URL(anchor.href, window.location.href);
    floridazeGtag('event', 'exit_click', {
      link_url: anchor.href,
      link_domain: url.hostname,
      link_text: (anchor.textContent || '').trim().slice(0, 100),
      page_path: window.location.pathname
    });
  }, true);

  function initScrollDepthTracking() {
    var thresholds = [25, 50, 75, 100];
    var fired = {};

    function checkScroll() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) - window.innerHeight;
      if (docHeight <= 0) return;
      var percent = (scrollTop / docHeight) * 100;

      thresholds.forEach(function (threshold) {
        if (!fired[threshold] && percent >= threshold) {
          fired[threshold] = true;
          floridazeGtag('event', 'scroll_depth', {
            percent_scrolled: threshold,
            page_path: window.location.pathname
          });
        }
      });

      if (fired[100]) {
        window.removeEventListener('scroll', onScroll);
      }
    }

    var scrollTimer = null;
    function onScroll() {
      if (scrollTimer) return;
      scrollTimer = window.setTimeout(function () {
        checkScroll();
        scrollTimer = null;
      }, 150);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    checkScroll();
  }

  if (window.floridazeScrollDepthEnabled) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initScrollDepthTracking);
    } else {
      initScrollDepthTracking();
    }
  }
})();
